import { type FocusEvent, type KeyboardEvent } from 'react';
import { UnderlineCellContainer } from './styled';
import { LONG_DASH } from '../EngineVersionUtils';
import { isEmptyValue } from './columns.utils';

export const UnderlineCell = ({
  value,
  onChange,
  centerAlign = false,
}: {
  value: string | number;
  onChange: (val: string) => void;
  centerAlign?: boolean;
}) => {
  const isEmpty = isEmptyValue(value);

  const handleBlur = (e: FocusEvent<HTMLSpanElement>) => {
    const newVal = e.currentTarget.textContent?.trim() || '';
    onChange(newVal);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <UnderlineCellContainer $hasOnChange={!!onChange} $centerAlign={centerAlign}>
      {isEmpty ? (
        <span className="empty-value">{LONG_DASH}</span>
      ) : (
        <span
          className="editable-span"
          contentEditable={!!onChange}
          suppressContentEditableWarning
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        >
          {value}
        </span>
      )}
    </UnderlineCellContainer>
  );
};
